import { Subscription } from 'react-hook-form/dist/utils/createSubject';
import { useEffect } from 'react';

function useSubscription(subscription: Subscription) {
    useEffect(() => () => subscription.unsubscribe(), [subscription]);
}

export default useSubscription;
